import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';
import { SanitizationComponent } from './sanitization/sanitization.component';
import { SendingFilesComponent } from './sending-files/sending-files.component';
import { HygieneTreatmentComponent } from './hygiene-treatment/hygiene-treatment.component';
import { SchedulingComponent } from './scheduling/scheduling.component';
import { SettingsComponent } from './settings/settings.component';

const routes: Routes = [
  { path: 'homepage', component: WelcomePageComponent },
  { path: 'sending-files', component: SendingFilesComponent },
  { path: 'sanitization', component: SanitizationComponent },
  { path: 'hygiene-treatment', component: HygieneTreatmentComponent },
  { path: 'scheduling', component: SchedulingComponent },
  { path: 'settings', component: SettingsComponent },
  //  { path: 'documentation/technique', component: TechniqueComponent },
  //  { path: 'documentation/vision', component: VisionComponent },
  //  { path: 'documentation/support', component: SupportDocumentationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeaturesRoutingModule {}
